import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classname from 'classnames'
import AvatarImage from 'src/components/Avatar/AvatarImage'
import { FormattedMessage, injectIntl } from 'react-intl'
import { getMimeType, logMessage } from 'src/utils/helpers'
import styles from './styles.module.less'
import EmailMessageType from './EmailMessageType'
import ImageMessageType from './ImageMessageType'
import AttachmentMessageType from './AttachmentMessageType'
import TextMessageType from './TextMessageType'

class MessageItem extends PureComponent {
  /**
   * Tries to find staff member data based on Twilio's author (staffMember.email === message.author).
   *
   * @return Requested attribute or null if not found
   */
  getStaffMemberAttribute = attribute => {
    const { message, staffMembers } = this.props
    console.log(message, 'message')
    try {
      if (message.author === 'bot') {
        return null
      }

      // Look for a Pathway staff member based on Twilio's "message.author",
      // better for situation where staff member changes avatar/name but it's not yet updated in Twilio Channel
      if (!(attribute && staffMembers && staffMembers.length > 0 && message.author)) {
        return null
      }

      // Staff member with email same as email of Twilio's message author
      const foundMember = staffMembers.filter(
        staffMember => staffMember.hasOwnProperty('email') && staffMember.email === message.author,
      )
      if (!(foundMember.length > 0 && foundMember[0])) {
        return null
      }

      // Try to find requested attribute
      if (!(foundMember[0].hasOwnProperty(attribute) && foundMember[0][attribute].length > 0)) {
        return null
      }
      return foundMember[0][attribute]
    } catch (e) {
      logMessage('Could not find staff member', e)
      return null
    }
  }

  getAvatar = () => {
    const { message } = this.props

    // If it's bot message, return bot avatar
    if (message.author === 'bot') {
      return require('./assets/chat_bot.jpg')
    }

    return this.getStaffMemberAttribute('avatar')
  }
  renderAuthor = () => {
    const { message } = this.props
    if (message.author === 'bot') {
      return (
        <span>
          <FormattedMessage id='app.chat.bot' defaultMessage='Bot' /> -{' '}
        </span>
      )
    }
    const authorName = this.getStaffMemberAttribute('name')
    if (authorName) {
      return <span>{authorName} - </span>
    }

    return ''
  }

  render() {
    const { outgoing, message } = this.props
    const contentType = getMimeType(message.attributes.contentType)

    const qaSelectors = classname({
      chat__message: true,
      'chat__message--is-bot': message.author === 'bot',
      'chat__message--is-not-bot': message.author !== 'bot',
      'chat__message--outgoing': !!outgoing,
      'chat__message--incoming': !outgoing,
      ['chat__message--type-' + contentType]: true,
    })

    const messageData = {
      message: message,
      renderAuthor: this.renderAuthor(),
    }

    return (
      <div
        className={classname(styles.message, { [styles.messageOutgoing]: outgoing })}
        data-qa={qaSelectors}
      >
        {!outgoing && (
          <div className={styles.avatar} data-qa='chat__message__avatar'>
            <AvatarImage avatar={this.getAvatar()} size='50px' />
          </div>
        )}
        <EmailMessageType
          display-if={message.attributes && contentType === 'email'}
          {...messageData}
          {...this.props}
        />
        <ImageMessageType
          display-if={message.attributes && contentType === 'image'}
          {...messageData}
          {...this.props}
        />
        <AttachmentMessageType
          display-if={message.attributes && contentType === 'file'}
          {...messageData}
          {...this.props}
        />
        <TextMessageType
          display-if={message.attributes && message.attributes.contentType === 'text'}
          botMessageIndex={this.props.botMessageIndex}
          {...messageData}
          {...this.props}
        />
      </div>
    )
  }
}

MessageItem.propTypes = {
  outgoing: PropTypes.bool,
  isWidget: PropTypes.bool,
  message: PropTypes.object,
  channel: PropTypes.object,
  userEmail: PropTypes.string,
}

MessageItem.defaultProps = {
  time: '',
  outgoing: false,
}

export default injectIntl(MessageItem)
